module.exports = __webpack_public_path__ + "static/img/s1.f39a020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/s1.png
// module id = oqyY
// module chunks = 1